if (process.env.NODE_ENV === 'production') {
  module.exports = require('./root.container.prod');
} else {
  module.exports = require('./root.container.dev');
}
